import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { PROCESS_AG_COPROPRIETES } from '../../../../config/process-ag-coproprietes';

export default function NoteConvocationPage() {
  const item = PROCESS_AG_COPROPRIETES.find((p) => p.slug === 'note-convocation');
  if (!item) return null;
  return (
    <AudienceParcoursStubPage
      parcours={item}
      audienceId="coproprietes"
      segment="process-ag"
      segmentLabel="Process AG"
      ctaFinalOverride={{
        eyebrow: 'Convocation · 21 jours avant la séance',
        title: 'Une note qui parle à tous les copropriétaires',
        description:
          "On co-écrit la note avec votre syndic et votre conseil syndical : plan de financement complet (MPR Copro, CEE, éco-PTZ, aides locales), chiffres traduits en langage clair, quote-part type par lot, et conformité formelle de la convocation.",
        primary: { label: 'Cadrer ma convocation AG', href: '/contact?source=coproprietes&besoin=convocation-ag' },
        secondary: { label: 'Voir la résolution AG', href: '/coproprietes/process-ag/resolution' },
        bullets: ['Envoi 21\u00a0j avant l\u2019AG (art. 9-1)', 'Plan de financement chiffré', 'Quote-part par lot calculée'],
      }}
    />
  );
}
